"use client"

import { createTheme, type MantineColorsTuple } from "@mantine/core"

const rBackBlue: MantineColorsTuple = [
  "#ebf9ff",
  "#d6effb",
  "#a8def8",
  "#78cdf7",
  "#58bef5",
  "#48b6f5",
  "#3fb1f6",
  "#339bdb",
  "#2589c4",
  "#0077ad",
]

const rBackBlueDarkMode: MantineColorsTuple = [
  "#f0f4f9",
  "#e0e4ed",
  "#bcc7db",
  "#96a8cb",
  "#768ebd",
  "#627eb4",
  "#5675b1",
  "#47649c",
  "#3d598c",
  "#314c7d",
]

export const theme = createTheme({
  colors: {
    rBackBlue,
    rBackBlueDarkMode,
  },
})
